import useAudioStreamEvents from '@/hooks/audio/useAudioStreamEvents';
import { ICaudioPlaybackStarted } from '@/helpers/events-intercom/audio';
import useSendIntercomEvent from '@/hooks/intercom/useSendIntercomEvent';
import useShakaPlayer from '@/hooks/audio/useShakaPlayer';
import useAudioTrackStreamEvents from '@/hooks/audio/useAudioTrackStreamEvents';

const AudioPlayerStreamEvents = () => {
  const { audioInteracted } = useShakaPlayer();

  // Send intercom event when the user first interacts with audio
  useSendIntercomEvent({
    createEvent: ICaudioPlaybackStarted,
    shouldSend: audioInteracted
  });

  // Handle audio stream events when the episode changes
  useAudioStreamEvents();

  // Handle audio stream events when the tracklist track changes
  useAudioTrackStreamEvents();
  
  return null;
};

export default AudioPlayerStreamEvents;